
import { threeFonts, loadFontGlyphs } from '../../../3dapps/js/fontManage'
import { makeGeom, addShapeExtrude2_2 } from '../../../3dapps/smallSoftware/modeller'
import { createPaths } from '../../../3dapps/js/fontPath'
import * as THREE from 'three'
import ClipperLib from '../../../3dapps/libs/clipper_unminified'
require('three-orbitcontrols');

export let scene;
export let camera;
export let renderer;
export let currentModel;
let scale;
let textSize; // 原始的尺寸
let renderCount = -1;
// let  grid;

export function incRenderCount() {
    renderCount += 2;
}

const material = new THREE.MeshPhongMaterial({
    reflectivity: 1,
    // side: THREE.DoubleSide,
});
import tidepool_negx_2 from '@/3dapps/skybox/tidepool/negx_2.jpg';
import tidepool_negy_2 from '@/3dapps/skybox/tidepool/negy_2.jpg';
import tidepool_negz_2 from '@/3dapps/skybox/tidepool/negz_2.jpg';
import tidepool_posx_2 from '@/3dapps/skybox/tidepool/posx_2.jpg';
import tidepool_posy_2 from '@/3dapps/skybox/tidepool/posy_2.jpg';
import tidepool_posz_2 from '@/3dapps/skybox/tidepool/posz_2.jpg';


function addSkyBox(scene, imgs) {
    new THREE.CubeTextureLoader().load(imgs, function (texture) { scene.background = texture; incRenderCount(); });
}export function initThree(canvas) {
    let canvas_bound = canvas.getBoundingClientRect();
    let controls;
    scene = new THREE.Scene(); //相机

    //创建3D世界
    let w = canvas_bound.width;
    let h = canvas_bound.height;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true, //抗锯齿
        preserveDrawingBuffer: true, //3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setClearColor(new THREE.Color("#ffffff")); //把渲染器的背景变成白色
    renderer.setPixelRatio(2);


    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(70, w / h, 0.1, 42000);
    //定义相机的x,y,z位置
    camera.position.set(7.726294567729223, 100.43708875007492, 384.54251990088227);
    camera.lookAt(scene.position); //把相机的位置渲染到场景中

    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas);

    controls.addEventListener("change", function () {
        renderCount += 2;
        // console.log(camera.position.x, camera.position.y, camera.position.z);
    });

    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 0;
    controls.maxDistance = 22000;

    // let axesHelper = new THREE.AxesHelper(100);
    // scene.add(axesHelper);

    // 灯光
    function addLights() {
        // 平行光
        let dirLight = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight.position.set(-30, 30, -30); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
        scene.add(dirLight);

        let dirLight2 = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight2.position.set(30, 30, 50);
        scene.add(dirLight2);

        // // 点光源
        // let light = new THREE.PointLight(0xffffff, 0.6, 100);
        // light.position.set(0, 0, 0);
        // scene.add(light);

        // 环境光
        let ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
        scene.add(ambientLight);

        // const dirLight3 = new THREE.DirectionalLight(0xffffff);
        // dirLight3.position.set(0, 0.1, 0);
        // scene.add(dirLight3);
    }
    addLights();

    // grid = new THREE.GridHelper(1200, 15, 0x000000, 0x000000);
    // grid.material.opacity = 0.2;
    // grid.material.transparent = true;
    // scene.add(grid);
    // grid.position.y = -1.5;
    addSkyBox(scene, [
        tidepool_negx_2,
        tidepool_posx_2,
        tidepool_posy_2,
        tidepool_negy_2,
        tidepool_negz_2,
        tidepool_posz_2,
    ]);
    // renderer.shadowMap.enabled = true;
    // renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    // renderCount++;

    //渲染场景
    function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
    }
    animate();
}

function vector2ToFPoint(p) {
    return new ClipperLib.FPoint(p.x, p.y);
}

function fPointToVector2(p) {
    return new THREE.Vector2(p.X, p.Y);
}

export function updateModel(vue, fontName, text, lineHeight, height, thickness) {
    if (currentModel) {
        scene.remove(currentModel);
        currentModel.geometry.dispose();
        currentModel = null;
    }

    if (thickness > height) {
        thickness = height;
    }
    
    return loadFontGlyphs(vue, fontName, text).then(() => {
        // 获取threejs字体
        let font = threeFonts[fontName];

        // 打断文字
        let n_col = Math.ceil(Math.sqrt(2 / 3 * text.length));
        let breakLines = [];
        for (let i = 0; i < text.length; i += n_col) {
            breakLines.push(text.substr(i, n_col));
        }
        let breakText = breakLines.join('\n');

        // 将字符串转换成几何形状
        let shapePaths = createPaths(breakText, lineHeight, font.data);

        // 模型的点
        let vertices = [];

        // 单独处理每个文字
        for (let i = 0; i < shapePaths.length; i++) {
            let shapes = shapePaths[i].toShapes();
            for (let j = 0; j < shapes.length; j++) {
                let shapePoints = shapes[j].extractPoints(36);
                let contour = shapePoints.shape;
                let holes = shapePoints.holes;
                let contourPath = contour.map(vector2ToFPoint);
                let holePath = holes.map(hole => hole.map(vector2ToFPoint));
                let origin = [
                    contourPath,
                    ...holePath
                ];
                let inner = new ClipperLib.PolyTree();
                // shrink
                let co = new ClipperLib.ClipperOffset(2, 0.25);
                co.AddPaths(origin, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
                co.Execute(inner, -thickness);
                // let innerContour = inner[0].map(fPointToVector2);
                // let innerHoles = inner.slice(1).map(poly => poly.map(fPointToVector2).reverse());
                // let innerHoles = inner.map(poly => poly.map(fPointToVector2).reverse());
                let innerPaths = [];
                let childs = inner.Childs();
                for (let node of childs) {
                    let paths = {
                        shape: node.Contour().map(fPointToVector2),
                        holes: []
                    };
                    let holeNodes = node.Childs();
                    for (let holeNode of holeNodes) {
                        paths.holes.push(holeNode.Contour().map(fPointToVector2));
                    }
                    innerPaths.push(paths);
                }

                addShapeExtrude2_2(vertices, { contour, holes, innerPaths, z1: 0, z2: height, z3: height - thickness });
            }
        }

        let geom = makeGeom(vertices);
        geom.center();
        let mesh = new THREE.Mesh(geom, material);
        scene.add(mesh);
        currentModel = mesh;
        return currentModel;

        // let data = initTextData(fontName, text);
        // let geom = addRotatePoly2(data, rotateAngle);
        // let mesh = new THREE.Mesh(geom, material);

        // let center = data.box.getCenter();
        // textSize = data.box.getSize();

        // scale = lineHeight / textSize.y;

        // mesh.position.x = -center.x * scale;
        // mesh.position.z = center.y * scale;
        // mesh.rotation.x = -0.5 * Math.PI;
        // mesh.scale.set(scale, scale, scale);
        // scene.add(mesh);

        // currentModel = mesh;
        // return currentModel;
    });
}

// 文本，计算必要的多边形数据，为旋转做准备。 
function initTextData(fontName, text) {
    // 获取threejs字体
    let font = threeFonts[fontName];

    // 将字符串转换成几何形状
    let shapes = font.generateShapes(text, 12);

    let baseVertexes = [];
    let baseVertexesR = [];

    let contourList = [];
    let holeList = [];

    for (let i = 0; i < shapes.length; i++) {
        // 形状转多边形
        let shapePoints = shapes[i].extractPoints(12);
        // 外围包裹
        let contour = shapePoints.shape;
        // 内部孔洞
        let holes = shapePoints.holes;

        // 计算上下表面：这是二维的
        let faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let vertices = contour.slice();
        for (let h = 0, hl = holes.length; h < hl; h++) {
            vertices = vertices.concat(holes[h]);
        }

        for (let f = 0, fl = faces.length; f < fl; f++) {
            let face = faces[f];
            baseVertexes.push(
                vertices[face[0]].x, vertices[face[0]].y, 0,
                vertices[face[1]].x, vertices[face[1]].y, 0,
                vertices[face[2]].x, vertices[face[2]].y, 0
            );
            baseVertexesR.push(
                vertices[face[0]].x, vertices[face[0]].y, 0,
                vertices[face[2]].x, vertices[face[2]].y, 0,
                vertices[face[1]].x, vertices[face[1]].y, 0
            );
        }

        contourList.push(contour);
        holeList.push(...holes);
    }

    let box = new THREE.Box2();
    for (let c of contourList) {
        for (let p of c) {
            box.expandByPoint(p);
        }
    }

    return {
        box,
        baseVertexes,
        baseVertexesR,
        contourList,
        holeList
    }
}


function makeGeomFromVertexes(vertexes) {
    let geom = new THREE.BufferGeometry();
    geom.setAttribute("position", new THREE.BufferAttribute(new Float32Array(vertexes), 3));
    geom.computeVertexNormals();
    return geom;
}

function addBox(vertexes, x1, x2, y1, y2, z1, z2) {
    let a1 = new THREE.Vector3(x1, y1, z1);
    let b1 = new THREE.Vector3(x2, y1, z1);
    let c1 = new THREE.Vector3(x2, y2, z1);
    let d1 = new THREE.Vector3(x1, y2, z1);

    let a2 = new THREE.Vector3(x1, y1, z2);
    let b2 = new THREE.Vector3(x2, y1, z2);
    let c2 = new THREE.Vector3(x2, y2, z2);
    let d2 = new THREE.Vector3(x1, y2, z2);

    addRect(vertexes, d1, c1, b1, a1);
    addRect(vertexes, a2, b2, c2, d2);
    addBound(vertexes, [a1, b1, c1, d1], [a2, b2, c2, d2]);
}


// 两个多边形之间的壁
function addBound(vertexes, poly1, poly2) {
    let v2_1 = poly1[poly1.length - 1];
    let v2_2 = poly2[poly2.length - 1];
    for (let i = 0; i < poly1.length; i++) {
        let v1_1 = poly1[i];
        let v1_2 = poly2[i];
        addRect(vertexes, v2_1, v1_1, v1_2, v2_2);

        v2_1 = v1_1;
        v2_2 = v1_2;
    }
}

// 将一个矩形转换为两个三角形
function addRect(vertexes, a, b, c, d) {
    addTriangle(vertexes, a, b, c);
    addTriangle(vertexes, a, c, d);
}

// 将一个三角形加入顶点数组
function addTriangle(vertexes, a, b, c) {
    vertexes.push(a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z);
}


// WEBPACK FOOTER //
// ./src/views/signText/scripts/initThree.js